module.exports = __webpack_public_path__ + "img/wt.ec8d83f8.jpg";